import { gql } from '@apollo/client';
import { ValidatingInput, ValidatingInputProps } from '~/components/validating-input';

export const VALIDATE = gql`
  query Flex_ValidateZipCode($zipCode: String!) {
    validation {
      zipCode(zipCode: $zipCode) {
        isValid
      }
    }
  }
`;

interface ZipCodeProps extends Omit<ValidatingInputProps, 'name' | 'label' | 'validate'> {
  label?: string;
}

export const ZipCode = ({ label = 'Zip code', placeholder, ...props }: ZipCodeProps) => {
  const validate = async ({ apollo, value }) => {
    if (value.length !== 5) return 'Please enter a zip code';

    const { data } = await apollo.query({
      fetchPolicy: 'no-cache',
      query: VALIDATE,
      variables: { zipCode: value },
    });

    if (!data.validation.zipCode.isValid) return 'Please enter a valid zip code';
    return true;
  };

  return (
    <ValidatingInput
      {...props}
      autoComplete="postal-code"
      label={label}
      name="zipCode"
      placeholder={placeholder}
      validate={validate}
      inputMode="numeric"
    />
  );
};
